export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/favicon-996d8248f580f8e26e6c45c67da9b5a6.png";